/**
 * AndVTreemap - 矩阵树图组件
 * 基于 Ant Design Charts Treemap
 */
import React from 'react';
import { Treemap } from '@ant-design/plots';
import { withBaseChart, parseJsonProp } from '../base/BaseChart';
import type { AndVTreemapProps } from '../base/types';

const DEFAULT_TREEMAP_DATA = {
  name: '设备分类',
  children: [
    { name: '影像设备', value: 120 },
    { name: '检验设备', value: 95 },
    { name: '监护设备', value: 80 },
    { name: '手术设备', value: 65 },
    { name: '康复设备', value: 45 },
  ],
};

const TreemapWithBase = withBaseChart<AndVTreemapProps>(Treemap, {
  chartType: 'AndVTreemap',
  defaultHeight: 300,
  defaultData: DEFAULT_TREEMAP_DATA,
});

export const AndVTreemap: React.FC<AndVTreemapProps> = (props) => {
  const { valueField, layout, ...baseProps } = props;

  const chartProps: Record<string, unknown> = { ...baseProps };

  if (valueField) chartProps.valueField = valueField;

  const layoutConfig = parseJsonProp(layout);
  if (layoutConfig !== undefined) chartProps.layout = layoutConfig;

  return <TreemapWithBase {...chartProps} />;
};

export type { AndVTreemapProps };
export default AndVTreemap;
